import { atlas, graphene } from 'graphql/tags'

const RetailerImportOrdersFragment = graphene`#graphql
  fragment RetailerImportOrdersFragment on Query {
    node(id: $retailerAccountId) {
      ... on RetailerAccount {
        id
        brandDoorMatches(orderBy: [{ field: NAME, order: ASCENDING }]) {
          edges {
            node {
              id
              code
              name
            }
          }
        }
        brandWarehouseMatches(
          orderBy: [
            { field: DEFAULT_WAREHOUSE, order: DESCENDING }
            { field: NAME, order: ASCENDING }
          ]
        ) {
          edges {
            node {
              id
              code
              name
              default
            }
          }
        }
      }
    }
  }
`

export const SecondStepSharedDataQuery = graphene`#graphql
  query SecondStepSharedData($retailerAccountId: ID!, $includeRetailer: Boolean!) {
    viewerBrand {
      id
      types {
        edges {
          node {
            id
            name
            code
          }
        }
      }
    }
    warehouses {
      edges {
        node {
          id
          name
          code
          default
        }
      }
    }
    ...RetailerImportOrdersFragment @include(if: $includeRetailer)
  }
  ${RetailerImportOrdersFragment}
`

export const RetailerBrandDoorsQuery = atlas`#graphql
  query RetailerBrandDoors($brandId: ID!) {
    brandDoors(brandId: $brandId) {
      edges {
        node {
          id
          name
          code
        }
      }
    }
  }
`

export const ConnectedAccountsQuery = graphene`#graphql
  query ConnectedAccountsQuery($searchFilter: String) {
    connectedAccounts(filterBy: { displayName: $searchFilter }) {
      edges {
        node {
          ... on RetailerAccount {
            id
            displayName
            locations(filterBy: { primary: true }) {
              edges {
                node {
                  id
                  state
                  city
                }
              }
            }
          }
          ... on BrandAccount {
            id
            displayName
          }
        }
      }
    }
  }
`
